<template>
    <v-app>
        <loader>
            <core-toolbar />

            <core-drawer/>

            <core-view />
        </loader>               
    </v-app>
</template>

<script>
import { mapMutations } from 'vuex'
import Loader from './components/material/Loader'

export default {
    components:{
        "loader": Loader
    }, 
    data(){
        return {
            uniqueId: `${this._uid}-app`
        }
    }, 
    created(){
        this.setLoaderText(this.$t("Common.checking-user-authorization"));
        this.setLoaderQueue(this.uniqueId);

        this.$security.events.$on("authenticated", this.clearLoader)
        if(this.$store.state.app.isAuthenticated){
            this.unsetLoaderQueue(this.uniqueId);
        }
        else if(!this.$route.meta.requiresAuth){
            this.unsetLoaderQueue(this.uniqueId);
        }
    },
    beforeDestroy(){
        this.$security.events.$off("authenticated", this.clearLoader);
    }, 
    methods:{
        ...mapMutations("app", ["setLoaderQueue", "unsetLoaderQueue", "setLoaderText"]), 
        clearLoader(){
            this.unsetLoaderQueue(this.uniqueId);
        }
    },       
}
</script>

<style lang="scss">
@import '@/styles/index.scss';
</style>
